export default __webpack_public_path__ + "static/media/icaew_background_l1.08358502.jpg";